import HcpPeerConnect from "@/page-components-hcp/peerconnect";

export default function HcpPeerConnectPage() {
  return <HcpPeerConnect />;
}

// Forward layout props to `_app` so it can wrap with the proper layout
HcpPeerConnectPage.getLayoutProps = (pageProps, router) => (
  typeof HcpPeerConnect.getLayoutProps === 'function'
    ? HcpPeerConnect.getLayoutProps(pageProps, router)
    : {}
);